import { Component, OnInit, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MaintenanceApiService } from '@kempoweroyj/ngx-maintenance-api-client';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthService } from 'providers/auth.service';
import { distinctUntilChanged } from 'rxjs/operators';
import { PopupService } from 'shared/popup-service/popup.service';
import { RoutedDialogDialogData } from 'shared/routed-dialog/routed-dialog.module';

export const screenshotRequiredPermissions = ['fleet.chargingStation.hardware.panel.screenshot'];
@Component({
    selector: 'ce-screenshot-dialog',
    templateUrl: './screenshot-dialog.component.html',
    styleUrls: ['./screenshot-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
@UntilDestroy()
export class ScreenshotDialogComponent implements OnInit {
    stationId: string;
    satId: number;
    url: string;

    loading = true;

    date: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public routedDialog: RoutedDialogDialogData,
        private maintenanceApi: MaintenanceApiService,
        private popup: PopupService,
        private cdRef: ChangeDetectorRef,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        this.authService
            .hasAccessTo$(screenshotRequiredPermissions, 'OR')
            .pipe(distinctUntilChanged(), untilDestroyed(this))
            .subscribe((allow) => {
                if (!allow) {
                    console.error('No required access', screenshotRequiredPermissions, 'OR');
                    this.popup.error(`No required access (${screenshotRequiredPermissions.join(' OR ')})`);

                    this.routedDialog.close();
                } else {
                    this.stationId = this.routedDialog.route.params.stationId;
                    this.satId = +this.routedDialog.route.params.satId;
                    this.getScreenshot();
                }
            });
    }

    async getScreenshot() {
        this.loading = true;
        this.cdRef.markForCheck();

        try {
            const now = new Date();
            const res = await this.maintenanceApi.screenshot(this.stationId, {
                satelliteId: this.satId,
                id: `${+now}`,
            });
            this.date = now.toISOString();
            this.url = res.url;
        } catch (e) {
            console.error(e);
            this.popup.error(`Could not fetch screenshot.`);
        } finally {
            this.loading = false;
            this.cdRef.markForCheck();
        }
    }
}
